import { useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

import close_img from '../../../assets/images/close.svg'

import '../../../components/_modals/modalStyle.css'
import VideoUploader from '../../../features/VideoUploader/VideoUploader';
import FileUploader from '../../../features/FileUploader/FileUploader';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchAddLink } from '../FolderApi';

import  Form from 'react-bootstrap/Form';
import  Modal from 'react-bootstrap/Modal';
import { loadOperations } from "../../../services/global/globalSlice";

export default function ContentCreateModal(props)  {
    const {show, type, onClose, folderData} = props
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [linkData, setLinkData] = useState({
        link_url: "",
        name: ""
    })

    const handleInputChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        setLinkData({
            ...linkData,
            [name]: value
        })
    }

    const handleAddLink = async () => {
        if(linkData.link_url && linkData.name){
            const response = await fetchAddLink({folder_id: folderData.folder_id}, [...folderData.links || [], linkData])
            if(response.success){
                toast.success(t.materials.link_added)
                props.onClose()
            } else {
                toast.error(t.materials.link_error)
            }
        } else {
            toast.error(t.materials.missing_link_data)
        }
    }

    const logUpload = (e) => {
        console.log(e);
        console.log('video uploaded');
        dispatch(loadOperations())
    }

    useEffect(()=>{
        setLinkData({
            name: "",
            link_url: ""
        })
    },[show])

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
        >
            <Modal.Body>
                <div className='d-flex align-items-center justify-content-between'>
                    <h2 className="text-center">{t.folder.add} {t.folder[type]}</h2>
                    <img src={close_img} alt='' onClick={onClose} />
                </div>
                {
                    type === 'video' && <>
                        <VideoUploader folderId={folderData.folder_id} onUpload={logUpload} onUploadEnd={props.onClose} />
                    </>
                }
                {
                    type === 'file' && <>
                        <FileUploader folderId={folderData.folder_id} onUpload={logUpload} onUploadEnd={props.onClose} />
                    </>
                }
                {
                    type === 'link' && <>
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.link_name}*</Form.Label>
                            <Form.Control type="text" value={linkData.name} name="name" onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.link}*</Form.Label>
                            <Form.Control type="url" value={linkData.link_url} name="link_url" placeholder={'https://...'} onChange={handleInputChange} />
                        </Form.Group>
                        <button className="mt-2 mx-auto" onClick={handleAddLink} >{t.folder.add}</button>
                    </>
                }
            </Modal.Body>
        </Modal>
    )
}
